import { authService } from '@/services/authService'

/**
 * Terminal screen shown when the authenticated user belongs to no valid
 * organization. Rendered by ProtectedRoute — outside AppLayout — so it uses
 * a standalone full-screen layout consistent with the session loader.
 */
export function NoOrganizationScreen() {
  const authUser = authService.getCurrentUser()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg p-8 text-center">
      <p className="text-lg font-semibold text-fg">Nenhuma organização encontrada</p>
      <p className="max-w-sm text-sm text-fg-muted">
        Sua conta não está associada a nenhuma organização ativa. Entre em contato
        com um administrador para obter acesso.
      </p>
      {authUser && (
        <button
          className="mt-2 text-sm text-fg-muted underline underline-offset-2 hover:text-fg"
          onClick={() => authService.logout()}
        >
          Sair ({authUser.email})
        </button>
      )}
    </div>
  )
}
